import React from "react";
import { Trans } from "react-i18next";
import ContactDetails from "../ContactDetails";
import { CurrencySymbol, formatCurrency, formatDate } from "services/util";
import Logo from "./Logo";

export const LayoutOneHeader = ({
    item,
    client,
    company,
    settings,
    t,
    doc_name,
    hideAttention,
    children,
    logo,
    taxed = true,
    qrCode,
    invoiceLogoStyle,
    invoiceTitleStyle,
    invoiceLabelStyle,
    invoiceContentStyle,
    header,
}) => {
    company = {
        ...company,
        Addresses: company?.Addresses?.map((address, index) => {
            return { ...address, AddressLine3: address.AddressLine3 || settings.plot_number, AddressLine4: address.AddressLine4 || settings.building_number }
        })
    };


    return (
        <>
            <Logo value={logo} invoiceLogoStyle={invoiceLogoStyle} />

            <div className={`row main my-3`}>
                <div className={qrCode ? "col-3" : "col-4"}>
                    <div className="mb-2">
                        <h4 style={invoiceTitleStyle || {}}>
                            <strong><Trans>{doc_name}</Trans></strong>
                        </h4>
                    </div>
                    <ContactDetails t={t} contact={client} />
                    {client.TaxNumber &&
                        <div>
                            <p className="my-0 py-0 font-weight-bold"><span style={invoiceLabelStyle}><Trans>VAT</Trans></span>: <span style={invoiceContentStyle}>{client.TaxNumber}</span></p>
                        </div>
                    }
                    {(client.RegistrationNumber || client.CompanyNumber) &&
                        <div>
                            <p className="my-0 py-0 font-weight-bold"><span style={invoiceLabelStyle}><Trans>CRN</Trans></span>: <span style={invoiceContentStyle}>{client.RegistrationNumber || client.CompanyNumber}</span></p>
                        </div>
                    }
                </div>

                <div className={qrCode ? "col-3" : "col-4"} >
                    {children}
                </div>

                {qrCode && (
                    <div className="qr-code col-3 p-0">
                        <img alt="QR code" src={qrCode} style={{ width: "100%", height: "auto" }} className="rounded border text-center" />
                    </div>
                )}


                <div className={qrCode ? "col-3" : "col-4"}>
                    {header ? (
                        <div style={{ whiteSpace: "pre-line" }}>{header}</div>
                    ) : (
                        <ContactDetails t={t} contact={company} hideAttention={hideAttention} />
                    )}

                    {company.TaxNumber &&
                        <div>
                            <p className="my-0 py-0 font-weight-bold"><span><Trans>VAT</Trans></span>: <span>{company.TaxNumber}</span></p>
                        </div>
                    }

                    {(company.RegistrationNumber || company.CompanyNumber) &&
                        <div>
                            <p className="my-0 py-0 font-weight-bold"><span><Trans>CRN</Trans></span>: <span>{company.RegistrationNumber || company.CompanyNumber}</span></p>
                        </div>
                    }

                    {item.Invoice &&
                        <div className="my-3">
                            <div className="border-dark border-top border-bottom p-2 font-weight-bold d-flex justify-content-end">
                                <span className="mr-5" style={invoiceLabelStyle}>
                                    <Trans>Total</Trans> <CurrencySymbol currency={item.Invoice.CurrencyCode} />
                                </span>{" "}
                                <span style={invoiceContentStyle}>{formatCurrency(item.Amount)}</span>
                            </div>
                        </div>

                    }
                </div>
            </div>
        </>
    )
};

export default LayoutOneHeader;
